
// Analytics Configuration
// Note: These are PUBLIC client-side keys that are safe to expose in the frontend
// They are designed to be used in browser environments

export const ANALYTICS_CONFIG = {
  // PostHog - PUBLIC key for client-side tracking
  POSTHOG_API_KEY: 'phc_KByuzZk4m1ZCkBCe30uqkWPahj7K2blNFbcN98FsnJN',
  POSTHOG_HOST: 'https://us.i.posthog.com',

  // Google Analytics - PUBLIC measurement ID for client-side tracking
  GA_MEASUREMENT_ID: 'G-2PNZHTHLS9',

  // Google Tag Manager - PUBLIC container ID for client-side tracking
  GTM_CONTAINER_ID: 'GTM-KHX9LH2F',

  // Reddit Pixel - PUBLIC tracking pixel
  REDDIT_PIXEL_ID: 'a2_i0oynyzzf2nz',

  // Social Media Pixels (for Phase 2) - These will be PUBLIC tracking pixels
  // TODO: Replace with actual values when ready to implement
  META_PIXEL_ID: 'YOUR_META_PIXEL_ID',
  LINKEDIN_PARTNER_ID: 'YOUR_LINKEDIN_PARTNER_ID',
  TIKTOK_PIXEL_ID: 'YOUR_TIKTOK_PIXEL_ID',
};

// Custom events for the OT Campaign and other key actions
export const ANALYTICS_EVENTS = {
  // OT Campaign specific events
  OT_PRESENTATION_STARTED: 'ot_presentation_started',
  OT_PRESENTATION_COMPLETED: 'ot_presentation_completed',
  OT_APPLICATION_STARTED: 'ot_application_started',
  OT_APPLICATION_COMPLETED: 'ot_application_completed',
  
  // General events
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  CONTACT_FORM_SUBMITTED: 'contact_form_submitted',
  CTA_CLICKED: 'cta_clicked',
  PAGE_SCROLL_DEPTH: 'page_scroll_depth',
  VIDEO_PLAYED: 'video_played',
  
  // User journey events
  JOURNEY_STARTED: 'user_journey_started',
  FEATURE_EXPLORED: 'feature_explored',
  PRICING_VIEWED: 'pricing_viewed',
};

// Reddit Pixel event types
export const REDDIT_EVENTS = {
  PAGE_VISIT: 'PageVisit',
  VIEW_CONTENT: 'ViewContent',
  LEAD: 'Lead',
  SIGN_UP: 'SignUp',
  CUSTOM: 'Custom',
};
